import React, { useEffect, useState } from 'react';
import styles from './warningModal.module.scss';
import { Warning } from '../components/Icons';
import { Link } from 'react-router-dom';

const DEVICE_WIDTH = 960;

const WarningModal = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const checkWindowSize = () => {
            setIsVisible(window.innerWidth <= DEVICE_WIDTH);
        };

        checkWindowSize();

        window.addEventListener('resize', checkWindowSize);

        return () => {
            window.removeEventListener('resize', checkWindowSize);
        };
    }, []);

    if (!isVisible) return null;

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <button
                    className={styles.closeButton}
                    onClick={() => setIsVisible(false)}
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        aria-label="關閉"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <line
                            x1="5"
                            y1="5"
                            x2="15"
                            y2="15"
                            stroke="#333"
                            strokeWidth="2"
                            strokeLinecap="round"
                        />
                        <line
                            x1="15"
                            y1="5"
                            x2="5"
                            y2="15"
                            stroke="#333"
                            strokeWidth="2"
                            strokeLinecap="round"
                        />
                    </svg>
                </button>
                <h2>
                    <Warning />
                    <span>注意</span>
                </h2>
                <p>此服務不支援寬度 {DEVICE_WIDTH}px 以下的螢幕裝置使用</p>
                <Link to="/statistics/ChishangEarthquake">返回調查頁面</Link>
            </div>
        </div>
    );
};

export default WarningModal;